import { createAction, props } from '@ngrx/store';

import { StepAssigneeTableItem } from '@main-application/management/pages/turnover-configuration/components/turnover-configuration-step-assignees/config/interfaces/step-assignee-table-item.interface';
import { PropertyAssignees } from '@main-application/management/pages/turnover-configuration/components/turnover-configuration-step-assignees/config/interfaces/step-assignees';
import { WorkflowStepEnumType } from '@shared/enums/workflow-step.enum';
import { IRadioButtonOption } from '@shared/interfaces/radio-button-option.interface';
import {
  RestPortfolioWorkflowStepAssignmentModel,
  RestWorkflowPortfolioStepAssignmentModel,
  RestWorkflowStepAssignmentModel,
} from '@shared/interfaces/rest-workflow-step-assignment-model.interface';

/* Load Responsible Parties */
export const loadResponsibleParties = createAction(
  '[StepAssignees] load responsible parties',
  props<{ portfolioId: number }>()
);

export const loadResponsiblePartiesSuccess = createAction(
  '[StepAssignees] load responsible parties Success',
  props<{ responsibleParties: RestWorkflowStepAssignmentModel[] }>()
);
export const loadResponsiblePartiesFailure = createAction('[StepAssignees] load responsible parties failure');

export const setAllStepAssigneeList = createAction(
  '[StepAssignees] setAllStepAssigneeList',
  props<{ allStepAssigneeList: StepAssigneeTableItem[] }>()
);

/* Create Responsible Parties */
export const createResponsibleParties = createAction(
  '[StepAssignees] create responsible parties',
  props<{ responsibleParties: RestWorkflowStepAssignmentModel[] }>()
);
export const createResponsiblePartiesSuccess = createAction(
  '[StepAssignees] create responsible parties success',
  props<{ createResponsibleParties: RestWorkflowStepAssignmentModel[] }>()
);
export const createResponsiblePartiesFailure = createAction('[StepAssignees] create responsible parties failure');

/* Update Responsible Parties */
export const updateResponsibleParties = createAction(
  '[StepAssignees] update responsible parties',
  props<{ responsibleParties: RestWorkflowStepAssignmentModel[] }>()
);
export const updateResponsiblePartiesSuccess = createAction(
  '[StepAssignees] update responsible parties success',

  props<{ updateResponsibleParties: RestWorkflowStepAssignmentModel[] }>()
);
export const updateResponsiblePartiesFailure = createAction('[StepAssignees] update responsible parties failure');

export const deleteResponsibleParties = createAction(
  '[StepAssignees] deleteResponsibleParties',
  props<{ propertyId: number; propertyName?: string; workflowStepEnumType?: WorkflowStepEnumType }>()
);
export const deleteResponsiblePartiesSuccess = createAction('[StepAssignees] deleteResponsiblePartiesSuccess');
export const deleteResponsiblePartiesFailure = createAction('[StepAssignees] deleteResponsiblePartiesFailure');

export const resetAssigneesUpdateStatus = createAction('[StepAssignees] reset Assignees Update Status');
export const resetAssigneesUpdateModel = createAction('[StepAssignees] reset Assignees Update model');

export const setEditedCell = createAction('[StepAssignees] set Edited Cell', props<{ uuid: string }>());
export const resetEditedCell = createAction('[StepAssignees] reset Edited Cell');

export const setUserRadioList = createAction(
  '[StepAssignees] set User Radio List',
  props<{ allUsers: IRadioButtonOption<number>[] }>()
);
export const resetAllUserList = createAction('[StepAssignees] reset All User List');

export const updatePropertyUser = createAction(
  '[StepAssignees] update Property User',
  props<{ propertyUsers: PropertyAssignees[] }>()
);
export const resetPropertyUser = createAction('[StepAssignees] reset Property User');

export const loadDefaultPortfolioResponsibleParties = createAction(
  '[StepAssignees] loadDefaultPortfolioResponsibleParties',
  props<{ portfolioId: number }>()
);
export const loadDefaultPortfolioResponsiblePartiesSuccess = createAction(
  '[StepAssignees] loadDefaultPortfolioResponsiblePartiesSuccess',
  props<{ responsibleParties: RestPortfolioWorkflowStepAssignmentModel[] }>()
);
export const loadDefaultPortfolioResponsiblePartiesFailed = createAction(
  '[StepAssignees] loadDefaultPortfolioResponsiblePartiesFailed'
);

/* Update Responsible Parties */
export const updatePortfolioResponsibleParties = createAction(
  '[StepAssignees] updatePortfolioResponsibleParties',
  props<{ portfolioId: number; responsibleParties: RestWorkflowPortfolioStepAssignmentModel[] }>()
);
export const updatePortfolioResponsiblePartiesSuccess = createAction(
  '[StepAssignees] updatePortfolioResponsiblePartiesSuccess'
);
export const updatePortfolioResponsiblePartiesFailure = createAction(
  '[StepAssignees] updatePortfolioResponsiblePartiesFailure'
);

export const deletePortfolioResponsibleParties = createAction(
  '[StepAssignees] deletePortfolioResponsibleParties',
  props<{ portfolioId: number; workflowStepType: WorkflowStepEnumType }>()
);
export const deletePortfolioResponsiblePartiesSuccess = createAction(
  '[StepAssignees] deletePortfolioResponsiblePartiesSuccess'
);
export const deletePortfolioResponsiblePartiesFailure = createAction(
  '[StepAssignees] deletePortfolioResponsiblePartiesFailure'
);

export const updatePropertyProjectManager = createAction(
  '[StepAssignees] updatePropertyProjectManager',
  props<{ propertyId: number; userId: number }>()
);
export const updatePropertyProjectManagerSuccess = createAction('[StepAssignees] updatePropertyProjectManagerSuccess');
export const updatePropertyProjectManagerFailed = createAction('[StepAssignees] updatePropertyProjectManagerFailed');

export const deletePropertyProjectManager = createAction(
  '[StepAssignees] deletePropertyProjectManager',
  props<{ propertyId: number; userId: number }>()
);
